import React, { Component } from "react";
import {
  FaTwitter,
  FaInstagram,
  FaFacebookF,
  FaLinkedinIn,
} from "react-icons/fa";
import { FiX, FiMenu } from "react-icons/fi";
import Scrollspy from "react-scrollspy";
import { isMobile } from "react-device-detect";
import $ from "jquery";
import { Label } from "reactstrap";
import LanguageDropdown from "../common/LanguageDropdown";
import i18n from "../../i18n"; // Import the instance
import { withTranslation } from "react-i18next";
import { pressPath } from "../../home/press/pressContent";

class HeaderThree extends Component {
  constructor(props) {
    super(props);
    this.menuTrigger = this.menuTrigger.bind(this);
    this.closeMenuTrigger = this.closeMenuTrigger.bind(this);
    this.stickyHeader = this.stickyHeader.bind(this);

    //  this.subMetuTrigger = this.subMetuTrigger.bind(this);
    window.addEventListener("load", function () {
      console.log("All assets are loaded");
    });
  }

  componentDidMount() {
    // For every <a> clicked, close the menu
    $("a").click(function () {
      document.querySelector(".header-wrapper").classList.remove("menu-open");
    });
  }

  menuTrigger() {
    document.querySelector(".header-wrapper").classList.toggle("menu-open");
  }

  closeMenuTrigger() {
    document.querySelector(".header-wrapper").classList.remove("menu-open");
  }

  handleLanguageChange(selected) {
    console.log("Selected Language:", selected.value);
    // Optionally change locale here
    i18n.changeLanguage(selected.value);
    //Cookies.set("language", selected.value);
    localStorage.setItem("lang", selected.value);
  }

  stickyHeader() {}


  render() {
    const { t, alwaysSticky } = this.props;
    const test = i18n.language
    console.log(test); // 'en', 'de', 'vi', etc.

    window.onload = function () {
      // Code runs after full page load
      if (!alwaysSticky) {
        console.log("Page fully loaded!");
        const branchName = document.getElementById("branchName");
        if (branchName) {
          branchName.style.opacity = 0;
        }
      } else {
        document.querySelector(".header--fixed").classList.add("sticky");
      }
    };
    window.addEventListener("scroll", function () {
      if (!alwaysSticky) {
        const branchName = document.getElementById("branchName");
        if (branchName) {
        const logo = document.getElementById("logo");
        var value = window.scrollY;
        if (value > 100) {
          document.querySelector(".header--fixed").classList.add("sticky");
        } else {
          document.querySelector(".header--fixed").classList.remove("sticky");
        }

        if (logo) {
          // Get the element's position relative to the viewport
          const rect = logo.getBoundingClientRect();
          if (rect.bottom < 70) {
            branchName.style.opacity = 1;
          } else {
            branchName.style.opacity = 0;
          }
        }
      }
      }
    });
    var elements = document.querySelectorAll(".has-droupdown > a");
    for (var i in elements) {
      if (elements.hasOwnProperty(i)) {
        elements[i].onclick = function () {
          this.parentElement
            .querySelector(".submenu")
            .classList.toggle("active");
          this.classList.toggle("open");
        };
      }
    }
    const { logo, color = "default-color" } = this.props;
    const gp_logo = `${process.env.PUBLIC_URL}/assets/images/gp_images/ecoshift-logo-brand-ecoshift-eco-app-movement-platform-ecoresponsible-ecopositive-ecofriendly-ecocentric.webp`;

    return (
      <header className={`header-area header-style-two header--fixed ${color}`}>
        <div className={window.innerWidth >= 768 ? "header-wrapper header-container mt-1 mb-1":  "header-wrapper header-container"}>
          <div
            className="cursor-pointer"
            id="branchName"
            style={{ opacity: !alwaysSticky && window.innerWidth < 768 ? 0 : undefined }}
          >
            <a href={this.props.homeLink} className="cursor-pointer">
              <div className="d-flex align-items-center gap-5 ">
                <img className="logo-text-56" src={gp_logo} alt='ecoshìt.eco' />
                <Label
                  className="text-color mb-0 cursor-pointer"
                  style={{
                    fontSize: "36px",
                    fontFamily:
                      '"Gill Sans", "Gill Sans MT", Calibri, sans-serif',
                  }}
                >
                  EcoShift
                </Label>
              </div>
            </a>
          </div>
          <div className="header-right">
            <nav className="mainmenunav d-lg-block ml--50">
              <Scrollspy
                className="mainmenu"
                items={["home", "why-ecoshift", "the-platform", "about-us", "keep-informed", "faqs"]}
                currentClassName="is-current"
                offset={0}
              >
                <li>
                  <a
                    href={`${process.env.PUBLIC_URL}/#home`}
                    className="text-color"
                  >
                    {t("Home")}
                  </a>
                </li>
                <li>
                  <a
                    href={`${process.env.PUBLIC_URL}/#why-ecoshift`}
                    className="text-color"
                  >
                    {t("Why EcoShift")}
                  </a>
                </li>
                <li>
                  <a
                    href={`${process.env.PUBLIC_URL}/#the-platform`}
                    className="text-color"
                  >
                    {t("The Platform")}
                  </a>
                </li>
                <li>
                  <a
                    href={`${process.env.PUBLIC_URL}/#about-us`}
                    className="text-color"
                  >
                    {t("About us")}
                  </a>
                </li>
                <li>
                  <a
                    href={`${process.env.PUBLIC_URL}/#keep-informed`}
                    className="text-color"
                  >
                    {t("Keep me informed")}
                  </a>
                </li>
                <li>
                  <a
                    href={`${process.env.PUBLIC_URL}/faqs`}
                    className="text-color"
                  >
                    {t("FAQs")}
                  </a>
                </li>
                <li>
                  <a
                    href={`${process.env.PUBLIC_URL}${pressPath}`}
                    className="text-color"
                  >
                    {t("In the press")}
                  </a>
                </li>
                <li>
                  <a
                    href="https://pro.ecoshift.eco/login"
                    className="text-color"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {t("Ecopro portal")}
                  </a>
                </li>
                {/* <li>
                  <a
                    href={`${process.env.PUBLIC_URL}/#home`}
                    className="text-color"
                  >
                    {t("Login for Pros")}
                  </a>
                </li> */}
                <li>
                  <LanguageDropdown key={i18n.language} onChange={this.handleLanguageChange} />
                </li>
              </Scrollspy>
            </nav>

            {/* Start Humberger Menu  */}
            <div className="humberger-menu d-block d-lg-none pl--20 pl_sm--10">
              <span
                onClick={this.menuTrigger}
                className="menutrigger text-white"
              >
                <FiMenu />
              </span>
            </div>
            {/* End Humberger Menu  */}
            <div className="close-menu d-block d-lg-none">
              <span onClick={this.closeMenuTrigger} className="closeTrigger">
                <FiX />
              </span>
            </div>
          </div>
        </div>
      </header>
    );
  }
}

export default withTranslation()(HeaderThree);
